/* eslint-disable max-len */
import React from 'react';
import { View, Image } from '@react-pdf/renderer';
import { styles } from '../styles';
import SchLogoImg from '../../../assets/Logo.png';

export const Logo = () => (
  <View style={styles.textRight} fixed>
    <Image
      style={styles.logo}
      src={SchLogoImg}
    />
  </View>
);
